import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Row } from "react-bootstrap";
import { STANDARD_SPACING } from "../config.js";
import FormFeedback from "./FormFeedback.js";
import { DEFAULT_COL_SIZINGS } from "./index.js";
export default function FormOffset(props) {
    const colSizing = { ...DEFAULT_COL_SIZINGS, ...props };
    return (_jsx(Row, { className: "mb-" + STANDARD_SPACING, children: _jsxs(Col, { xs: { offset: colSizing.xs }, sm: { offset: colSizing.sm }, md: { offset: colSizing.md }, lg: { offset: colSizing.lg }, xl: { offset: colSizing.xl }, xxl: { offset: colSizing.xxl }, children: [props.children, _jsx(FormFeedback, { field: props.field })] }) }));
}
